export const cartService = {
  getCart: async () => {
    try {
      const cart = await JSON.parse(localStorage.getItem("cart"));
      return Array.isArray(cart) ? cart : [];
    } catch {
      return [];
    }
  },

  saveCart: (cart) => {
    if (!Array.isArray(cart)) {
      throw new Error("Cart must be an array of cart items");
    }
    localStorage.setItem("cart", JSON.stringify(cart));
  },

  pushToCart: async (cartItem) => {
    let cart = await cartService.getCart();
    let cartId = Math.floor(1000 + Math.random() * 9000);

    const existingIndex = cart.findIndex(
      (item) =>
        item.productId === cartItem.productId &&
        item.size === cartItem.size &&
        item.color === cartItem.color
    );

    if (existingIndex !== -1) {
      cart[existingIndex].quantity += cartItem.quantity;
    } else {
      cartItem.id = cartId;
      cart.push(cartItem);
    }
    cartService.saveCart(cart);
  },

  removeFromCart: async (cartId) => {
    let cart = await cartService.getCart();
    cart = cart.filter((item) => !(item.id === cartId));
    cartService.saveCart(cart);
  },

  updateQuantity: async (cartItem, newQuantity) => {
    let cart = await cartService.getCart();
    const index = cart.findIndex((item) => item.id === cartItem.id);
    if (index !== -1) {
      const unitPrice = cart[index].price / cart[index].quantity;
      cart[index].quantity = newQuantity;
      cart[index].price = unitPrice * newQuantity;
      cartService.saveCart(cart);
    }
  },

  clearCart: async () => {
    localStorage.removeItem("cart");
  },
};
